export function normalize(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

export function plural(count: number, singular: string, pluralForm?: string): string {
  return `${count} ${count > 1 ? pluralForm ?? `${singular}s` : singular}`;
}
